export default "__VITE_ASSET__DwZzp7qk__"